import React from 'react';

import BlockActionSliderImage from './BlockActionSliderImage';

const BlockActionSlider = ({ isHomepage, title, type, link, banerId }) => {
  var position = 0;
  if (type === 'loyalty') {
    position = 4;
  } else if (type === 'inStockAgain') {
    position = 5;
  } else if (type === 'weekAction') {
    position = 6;
  } else if (type === 'recommendedForYou') {
    position = 7;
  }

  var actionSliderClass = '';
  if (isHomepage == 'true') {
    actionSliderClass = 'homepage-content-body-special-block';
  } else {
    actionSliderClass = 'content-body-special-block';
  }

  return (
    <>
      <div className="special-action-block loyalty-block-content">
        <div className={actionSliderClass}>
          <BlockActionSliderImage isHomepage={isHomepage} title={title} position={banerId} type={type} link={link} />        </div>
      </div>
    </>
  )
};

export default BlockActionSlider;
